import React from 'react';
import Hero from '../components/Hero';
import InfoSection from '../components/InfoSection';

export default function HomePage() {
  return (
    <>
      <Hero />
      <InfoSection />
    </>
  );
}
